import React from 'react';
import {
	IonContent,
	IonPage,
	IonRefresher,
	IonRefresherContent,
} from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { Filter, Header, ItemsSlider, Oops, TabsOffset } from 'components';
import { analytics, axius, cartFx, func, services, types } from 'utils';
import { _store, _update } from '_Store';
import { Alert } from 'react-bootstrap';

let refresher: any = null;

interface Props extends RouteComponentProps, types.StateProps {}

const Home: React.FC<Props> = (props) => {
	const [step, setStep] = React.useState(0);
	const [data, setData] = React.useState([]);
	const [chunks, setChunks] = React.useState([]);
	const [loading, setLoading] = React.useState(true);
	const [bigData, setBigData] = React.useState({});
	const [available, setAvailable] = React.useState(true);

	const {
		__data: {
			categories,
			activeStore,
			location,
			settings: { countries },
			promotions,
		},
		__auth: { user },
	} = _store.useState();

	React.useEffect(() => {
		analytics.trackEvent(analytics.eventTypes.VIEW_STORE, {
			store: activeStore.code,
		});
		// eslint-disable-next-line
	}, []);

	React.useEffect(() => {
		setAvailable(
			countries
				.map((ol: types.Country) => {
					return ol.code.toLowerCase();
				})
				.includes(location.address?.iso?.toLowerCase())
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [countries, location.address?.iso]);

	React.useEffect(() => {
		if (available && activeStore.code) {
			getData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		available,
		activeStore.code,
		location.option,
		location.address?.x,
		location.address?.y,
	]);

	const getData = () => {
		func.scrollToTop();
		setLoading(true);
		if (activeStore.code) {
			services.categories(activeStore).then((catigories) => {
				_update.data(
					'categories',
					catigories
						.sort((a, b) => +a.sequence - +b.sequence)
						.filter((ctg) => !ctg.name.toLowerCase().includes('other'))
				);
				axius
					.post('search/home', {
						city: location.address.city,
						stores: [activeStore.code],
						latitude: location.address.x,
						longitude: location.address.y,
						categories: catigories.map((ctg: types.Category) => ctg.id),
						resultTypes: ['items'],
						deliveryOptions: [location.option],
					})
					.then((res) => {
						if (res.status === 201) {
							const c = func.chunk(Object.keys(res.items), 30);
							setData(c[0] || []);
							setChunks(c);
							setBigData(res.items);
							_update.data('home', res.items);
							_update.data('activeStore', res.stores[0]);
						} else {
							setData([]);
							setChunks([]);
							setBigData({});
						}
						refresher && refresher.detail.complete();
						setLoading(false);
					});
			});
		} else {
			setLoading(false);
		}
	};

	const getNext = () => {
		setStep(step + 1);
		setData(data.concat(chunks[step + 1]));
	};

	const hasMenuItems = !!(
		activeStore.code &&
		// categories.length > 0 &&
		data.length > 0
	);
	const allItems: types.Item[] = Object.keys(bigData)
		.map((ctg) => bigData[ctg as keyof typeof bigData])
		.flat();
	const itemsWithPromo = allItems.filter(
		(item) => cartFx.myPromos({ promotions, item, user }).length > 0
	);
	const hasPromo = promotions.find(
		(p) =>
			p.type.includes('ALL') &&
			p.stores.includes(activeStore.code) &&
			(p.preferences.firstTime ? user.preferences?.isFirstTime : true)
	);

	return (
		<IonPage id="Home">
			<Header
				{...props}
				showSearch={hasMenuItems}
				showSegments={false}
				goBack={() => props.history.replace('/home')}
			/>
			{/* backgroundImage: `url(assets/img/bg.png)`, */}
			<IonContent
				fullscreen={false}
				className="bg-img"
				style={{ backgroundAttachment: 'fixed', height: '100%' }}
			>
				<IonRefresher
					slot="fixed"
					onIonRefresh={(e) => {
						refresher = e;
						getData();
					}}
				>
					<IonRefresherContent></IonRefresherContent>
				</IonRefresher>

				<div className="">
					{loading ? (
						<>
							{categories.map((ctg) => {
								let id = `${ctg.id}`;
								return (
									<div key={ctg.id}>
										<ItemsSlider
											{...props}
											key={id}
											id={id}
											title={ctg.name}
											data={[]}
											loading={true}
										/>
									</div>
								);
							})}
						</>
					) : (
						<>
							{hasMenuItems ? (
								<div>
									<div className="d-flex justify-content-between align-items-center">
										<Filter {...props} />
										<div className="pr-3 d-flex- align-items-center hide">
											<span className="fw-500s small text-muted">
												{func.venueName(activeStore)}
											</span>
										</div>
									</div>
									{hasPromo && (
										<div className="px-3s">
											<Alert
												variant="warning"
												className="small text-xs mb-0 d-flex align-items-center"
											>
												<i
													className="fa fa-gift primary fa-2x mr-2"
													style={{ opacity: '0.9' }}
												/>{' '}
												{hasPromo.description}
											</Alert>
										</div>
									)}
									{itemsWithPromo.length > 0 && (
										<div className="pb-4">
											<ItemsSlider
												{...props}
												id="hot-deals"
												title="🔥 HOT DEALS"
												data={itemsWithPromo}
												loading={false}
											/>
										</div>
									)}
									{!loading &&
										data.map((i: string) => {
											let id = '';
											const ctg = categories.find((c) => c.id === i);
											const smallData = ((bigData as any)[i] || [])
												.map((row: types.Item) => {
													const store = activeStore;
													return {
														...row,
														distance: +func.distanceMatrix(
															{
																lat: location?.address?.x,
																lng: location?.address?.y,
															},
															{
																lat: store.address.x,
																lng: store.address.y,
															},
															true
														),
													};
												})
												.filter((item: types.Item) => {
													const itemAvailableInStore =
														!activeStore.preferences?.itemsAvailable ||
														activeStore.preferences?.itemsAvailable.includes(
															item.code
														);
													return (
														item.status === types.ItemStatuses.PUBLISHED &&
														itemAvailableInStore
													);
												});
											id = `${ctg?.id}`;
											return ctg ? (
												smallData.length > 0 && (
													<div
														key={id}
														className="pb-4"
														style={{ borderTop: '10px solid #f9f6f6' }}
													>
														<ItemsSlider
															{...props}
															key={id}
															id={id}
															title={ctg.name}
															data={smallData}
															loading={false}
															display={ctg.id ? 'item' : 'store'}
														/>
													</div>
												)
											) : (
												<div key={i}>
													<ItemsSlider
														{...props}
														key={id}
														id={id}
														title={''}
														data={[]}
														loading={true}
													/>
												</div>
											);
										})}

									{!loading && chunks.flat().length > data.length && (
										<div
											className="text-center pointer small mt-4"
											onClick={() => getNext()}
										>
											load more
										</div>
									)}
								</div>
							) : (
								<Oops />
							)}
						</>
					)}
				</div>
				<TabsOffset />
			</IonContent>
		</IonPage>
	);
};

export default Home;
